<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useSummaryReportArchive } from '../composables/useSummaryReportArchive';

const props = defineProps({
  value: {
    type: [String, Number],
    default: '',
  },
  metricKey: {
    type: String,
    required: true,
  },
  row: {
    type: Object,
    default: () => ({}),
  },
  archiveContext: {
    type: Object,
    default: () => ({}),
  },
  rawValue: {
    type: [Number, String],
    default: null,
  },
  title: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();
const { openArchive, isMetricLinkable } = useSummaryReportArchive();

const numericValue = computed(() => {
  if (props.rawValue !== null && props.rawValue !== undefined) {
    return Number(props.rawValue);
  }
  const parsed = Number(String(props.value).replace(/,/g, ''));
  return Number.isNaN(parsed) ? 0 : parsed;
});

const linkable = computed(
  () =>
    props.value &&
    props.value !== '--' &&
    numericValue.value > 0 &&
    isMetricLinkable(props.metricKey, props.archiveContext.reportType)
);

const onClick = () => {
  if (!linkable.value) return;

  openArchive({
    metricKey: props.metricKey,
    reportType: props.archiveContext.reportType,
    row: props.row,
    context: props.archiveContext,
  });
};
</script>

<template>
  <button
    v-if="linkable"
    type="button"
    class="tabular-nums text-n-brand hover:underline cursor-pointer"
    :title="title || t('SUMMARY_REPORTS.ARCHIVE_LINK.TOOLTIP')"
    @click="onClick"
  >
    {{ value }}
  </button>
  <span
    v-else
    :class="value === '--' ? 'text-n-slate-11' : 'tabular-nums text-n-slate-12'"
  >
    {{ value }}
  </span>
</template>
